import { Icon24PointCloudLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PointCloudIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1934_673)">
        <path
          d="M3.06555 7.21118L11.9999 12.1012L20.9343 7.21118"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8947 7.13542C20.8261 7.01999 20.7278 6.92509 20.61 6.86063L12.36 2.34376C12.2496 2.28336 12.1258 2.25171 12 2.25171C11.8742 2.25171 11.7504 2.28336 11.64 2.34376L3.39 6.86063C3.2722 6.92509 3.17386 7.01999 3.10526 7.13542C3.03666 7.25086 3.0003 7.3826 3 7.51688V16.4831C3.0003 16.6174 3.03666 16.7492 3.10526 16.8646C3.17386 16.98 3.2722 17.0749 3.39 17.1394L11.64 21.6563C11.7504 21.7167 11.8742 21.7483 12 21.7483"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.1021V21.7499"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3125 5.3252C13.6232 5.3252 13.875 5.07336 13.875 4.7627C13.875 4.45204 13.6232 4.2002 13.3125 4.2002C13.0018 4.2002 12.75 4.45204 12.75 4.7627C12.75 5.07336 13.0018 5.3252 13.3125 5.3252Z"
          fill="currentColor"
        />
        <path
          d="M17.0625 7.6499C17.3732 7.6499 17.625 7.39806 17.625 7.0874C17.625 6.77674 17.3732 6.5249 17.0625 6.5249C16.7518 6.5249 16.5 6.77674 16.5 7.0874C16.5 7.39806 16.7518 7.6499 17.0625 7.6499Z"
          fill="currentColor"
        />
        <path
          d="M15.1875 6.6001C15.4982 6.6001 15.75 6.34826 15.75 6.0376C15.75 5.72694 15.4982 5.4751 15.1875 5.4751C14.8768 5.4751 14.625 5.72694 14.625 6.0376C14.625 6.34826 14.8768 6.6001 15.1875 6.6001Z"
          fill="currentColor"
        />
        <path
          d="M18.5625 11.625C18.8732 11.625 19.125 11.3732 19.125 11.0625C19.125 10.7518 18.8732 10.5 18.5625 10.5C18.2518 10.5 18 10.7518 18 11.0625C18 11.3732 18.2518 11.625 18.5625 11.625Z"
          fill="currentColor"
        />
        <path
          d="M18.5625 13.875C18.8732 13.875 19.125 13.6232 19.125 13.3125C19.125 13.0018 18.8732 12.75 18.5625 12.75C18.2518 12.75 18 13.0018 18 13.3125C18 13.6232 18.2518 13.875 18.5625 13.875Z"
          fill="currentColor"
        />
        <path
          d="M18.5625 16.125C18.8732 16.125 19.125 15.8732 19.125 15.5625C19.125 15.2518 18.8732 15 18.5625 15C18.2518 15 18 15.2518 18 15.5625C18 15.8732 18.2518 16.125 18.5625 16.125Z"
          fill="currentColor"
        />
        <path
          d="M18.5625 18.375C18.8732 18.375 19.125 18.1232 19.125 17.8125C19.125 17.5018 18.8732 17.25 18.5625 17.25C18.2518 17.25 18 17.5018 18 17.8125C18 18.1232 18.2518 18.375 18.5625 18.375Z"
          fill="currentColor"
        />
        <path
          d="M13.3125 7.6499C13.6232 7.6499 13.875 7.39806 13.875 7.0874C13.875 6.77674 13.6232 6.5249 13.3125 6.5249C13.0018 6.5249 12.75 6.77674 12.75 7.0874C12.75 7.39806 13.0018 7.6499 13.3125 7.6499Z"
          fill="currentColor"
        />
        <path
          d="M15.1875 8.7749C15.4982 8.7749 15.75 8.52306 15.75 8.2124C15.75 7.90174 15.4982 7.6499 15.1875 7.6499C14.8768 7.6499 14.625 7.90174 14.625 8.2124C14.625 8.52306 14.8768 8.7749 15.1875 8.7749Z"
          fill="currentColor"
        />
        <path
          d="M13.3125 9.9751C13.6232 9.9751 13.875 9.72326 13.875 9.4126C13.875 9.10194 13.6232 8.8501 13.3125 8.8501C13.0018 8.8501 12.75 9.10194 12.75 9.4126C12.75 9.72326 13.0018 9.9751 13.3125 9.9751Z"
          fill="currentColor"
        />
        <path
          d="M20.8125 10.125C21.1232 10.125 21.375 9.87316 21.375 9.5625C21.375 9.25184 21.1232 9 20.8125 9C20.5018 9 20.25 9.25184 20.25 9.5625C20.25 9.87316 20.5018 10.125 20.8125 10.125Z"
          fill="currentColor"
        />
        <path
          d="M20.8125 12.375C21.1232 12.375 21.375 12.1232 21.375 11.8125C21.375 11.5018 21.1232 11.25 20.8125 11.25C20.5018 11.25 20.25 11.5018 20.25 11.8125C20.25 12.1232 20.5018 12.375 20.8125 12.375Z"
          fill="currentColor"
        />
        <path
          d="M20.8125 14.625C21.1232 14.625 21.375 14.3732 21.375 14.0625C21.375 13.7518 21.1232 13.5 20.8125 13.5C20.5018 13.5 20.25 13.7518 20.25 14.0625C20.25 14.3732 20.5018 14.625 20.8125 14.625Z"
          fill="currentColor"
        />
        <path
          d="M20.8125 16.875C21.1232 16.875 21.375 16.6232 21.375 16.3125C21.375 16.0018 21.1232 15.75 20.8125 15.75C20.5018 15.75 20.25 16.0018 20.25 16.3125C20.25 16.6232 20.5018 16.875 20.8125 16.875Z"
          fill="currentColor"
        />
        <path
          d="M16.3125 12.9751C16.6232 12.9751 16.875 12.7233 16.875 12.4126C16.875 12.1019 16.6232 11.8501 16.3125 11.8501C16.0018 11.8501 15.75 12.1019 15.75 12.4126C15.75 12.7233 16.0018 12.9751 16.3125 12.9751Z"
          fill="currentColor"
        />
        <path
          d="M16.3125 15.2251C16.6232 15.2251 16.875 14.9733 16.875 14.6626C16.875 14.3519 16.6232 14.1001 16.3125 14.1001C16.0018 14.1001 15.75 14.3519 15.75 14.6626C15.75 14.9733 16.0018 15.2251 16.3125 15.2251Z"
          fill="currentColor"
        />
        <path
          d="M16.3125 17.4751C16.6232 17.4751 16.875 17.2233 16.875 16.9126C16.875 16.6019 16.6232 16.3501 16.3125 16.3501C16.0018 16.3501 15.75 16.6019 15.75 16.9126C15.75 17.2233 16.0018 17.4751 16.3125 17.4751Z"
          fill="currentColor"
        />
        <path
          d="M16.3125 19.7251C16.6232 19.7251 16.875 19.4733 16.875 19.1626C16.875 18.8519 16.6232 18.6001 16.3125 18.6001C16.0018 18.6001 15.75 18.8519 15.75 19.1626C15.75 19.4733 16.0018 19.7251 16.3125 19.7251Z"
          fill="currentColor"
        />
        <path
          d="M14.0625 14.25C14.3732 14.25 14.625 13.9982 14.625 13.6875C14.625 13.3768 14.3732 13.125 14.0625 13.125C13.7518 13.125 13.5 13.3768 13.5 13.6875C13.5 13.9982 13.7518 14.25 14.0625 14.25Z"
          fill="currentColor"
        />
        <path
          d="M14.0625 16.5C14.3732 16.5 14.625 16.2482 14.625 15.9375C14.625 15.6268 14.3732 15.375 14.0625 15.375C13.7518 15.375 13.5 15.6268 13.5 15.9375C13.5 16.2482 13.7518 16.5 14.0625 16.5Z"
          fill="currentColor"
        />
        <path
          d="M14.0625 18.75C14.3732 18.75 14.625 18.4982 14.625 18.1875C14.625 17.8768 14.3732 17.625 14.0625 17.625C13.7518 17.625 13.5 17.8768 13.5 18.1875C13.5 18.4982 13.7518 18.75 14.0625 18.75Z"
          fill="currentColor"
        />
        <path
          d="M14.0625 21C14.3732 21 14.625 20.7482 14.625 20.4375C14.625 20.1268 14.3732 19.875 14.0625 19.875C13.7518 19.875 13.5 20.1268 13.5 20.4375C13.5 20.7482 13.7518 21 14.0625 21Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1934_673">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PointCloudIcon = fplIcon(PointCloudIconLocal, Icon24PointCloudLarge);
